// @ts-nocheck
// Generated by tools/client-contract.mjs; Foundation contract SHA-256 35d9836b9bfa444a792da4bdf46b7e131ba58927cacbdf9a920cc0d5708d454f.
export default [
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations"
    ],
    "capability": "identity.organizations:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations"
    ],
    "capability": "identity.organizations:create"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null
    ],
    "capability": "identity.organizations:update"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null
    ],
    "capability": "identity.organizations:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "invitations"
    ],
    "capability": "identity.invitations:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "invitations"
    ],
    "capability": "identity.invitations:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "invitations",
      null,
      "revoke"
    ],
    "capability": "identity.invitations:revoke"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "capabilities"
    ],
    "capability": "identity.roles:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "roles"
    ],
    "capability": "identity.roles:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "roles"
    ],
    "capability": "identity.roles:create"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "roles",
      null
    ],
    "capability": "identity.roles:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "roles",
      null
    ],
    "capability": "identity.roles:update"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "organizations",
      null,
      "roles",
      null
    ],
    "capability": "identity.roles:delete"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "memberships"
    ],
    "capability": "identity.memberships:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "memberships",
      null
    ],
    "capability": "identity.memberships:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "memberships",
      null
    ],
    "capability": "identity.memberships:update"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "organizations",
      null,
      "memberships",
      null
    ],
    "capability": "identity.memberships:delete"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "clients"
    ],
    "capability": "developer.clients:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "clients"
    ],
    "capability": "developer.clients:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "clients",
      null,
      "revoke"
    ],
    "capability": "developer.clients:revoke"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "webhook-endpoints"
    ],
    "capability": "developer.webhook_endpoints:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "webhook-endpoints"
    ],
    "capability": "developer.webhook_endpoints:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "webhook-endpoints",
      null,
      "test-events"
    ],
    "capability": "developer.webhook_endpoints:test"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "grants"
    ],
    "capability": "identity.grants:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "grants",
      null,
      "revoke"
    ],
    "capability": "identity.grants:revoke"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "me"
    ],
    "capability": "identity.self:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "me",
      "passkey-registrations"
    ],
    "capability": "identity.self:manage"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "me",
      "passkey-registrations",
      null,
      "complete"
    ],
    "capability": "identity.self:manage"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "me",
      "passkeys"
    ],
    "capability": "identity.self:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "me",
      "passkeys",
      null
    ],
    "capability": "identity.self:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "me",
      "passkeys",
      null
    ],
    "capability": "identity.self:manage"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "me",
      "passkeys",
      null
    ],
    "capability": "identity.self:manage"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "me",
      "sessions"
    ],
    "capability": "identity.self:manage"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "me",
      "sessions"
    ],
    "capability": "identity.self:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "me",
      "sessions",
      null,
      "revoke"
    ],
    "capability": "identity.self:manage"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "me",
      "memberships",
      null
    ],
    "capability": "identity.self:manage"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "deactivate"
    ],
    "capability": "identity.organizations:deactivate"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "reactivate"
    ],
    "capability": "identity.organizations:reactivate"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "invitations",
      null,
      "resend"
    ],
    "capability": "identity.invitations:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "memberships",
      null,
      "recovery"
    ],
    "capability": "identity.memberships:recover"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "events"
    ],
    "capability": "developer.events:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "webhook-endpoints",
      null
    ],
    "capability": "developer.webhook_endpoints:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "webhook-endpoints",
      null
    ],
    "capability": "developer.webhook_endpoints:update"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "organizations",
      null,
      "webhook-endpoints",
      null
    ],
    "capability": "developer.webhook_endpoints:delete"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "webhook-endpoints",
      null,
      "secret",
      "rotate"
    ],
    "capability": "developer.webhook_endpoints:update"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "webhook-endpoints",
      null,
      "deliveries"
    ],
    "capability": "developer.webhook_endpoints:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "webhook-endpoints",
      null,
      "deliveries",
      null,
      "redeliver"
    ],
    "capability": "developer.webhook_endpoints:update"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "webhook-endpoints",
      null,
      "recover"
    ],
    "capability": "developer.webhook_endpoints:update"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "ai-policy"
    ],
    "capability": "agents.ai_policy:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "ai-policy"
    ],
    "capability": "agents.ai_policy:update"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "agents"
    ],
    "capability": "agents.agents:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "agents"
    ],
    "capability": "agents.agents:create"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "agents",
      null
    ],
    "capability": "agents.agents:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "agents",
      null
    ],
    "capability": "agents.agents:update"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "agents",
      "suspend-all"
    ],
    "capability": "agents.agents:suspend"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "proposals"
    ],
    "capability": "agents.proposals:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "proposals",
      null
    ],
    "capability": "agents.proposals:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "proposals",
      null,
      "decision"
    ],
    "capability": "agents.proposals:decide"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "me",
      "grants"
    ],
    "capability": "identity.self:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "me",
      "grants",
      null,
      "revoke"
    ],
    "capability": "identity.self:manage"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "mail-domains"
    ],
    "capability": "comms.mail_domains:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "mail-domains"
    ],
    "capability": "comms.mail_domains:create"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "mail-domains",
      null
    ],
    "capability": "comms.mail_domains:read"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "organizations",
      null,
      "mail-domains",
      null
    ],
    "capability": "comms.mail_domains:delete"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "mail-domains",
      null,
      "verify"
    ],
    "capability": "comms.mail_domains:create"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "mailboxes"
    ],
    "capability": "comms.mailboxes:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "mailboxes"
    ],
    "capability": "comms.mailboxes:create"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "mailboxes",
      null
    ],
    "capability": "comms.mailboxes:update"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "organizations",
      null,
      "mailboxes",
      null
    ],
    "capability": "comms.mailboxes:delete"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "mailboxes",
      null,
      "inbound-messages"
    ],
    "capability": "comms.messages:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-messages",
      null
    ],
    "capability": "comms.messages:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "mailboxes",
      null,
      "messages"
    ],
    "capability": "comms.messages:send"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "messages",
      null
    ],
    "capability": "comms.messages:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "receiving-accounts"
    ],
    "capability": "money.receiving_accounts:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "receiving-accounts"
    ],
    "capability": "money.receiving_accounts:create"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests"
    ],
    "capability": "money.payment_requests:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests"
    ],
    "capability": "money.payment_requests:create"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests",
      null
    ],
    "capability": "money.payment_requests:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests",
      null,
      "revisions"
    ],
    "capability": "money.payment_requests:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests",
      null,
      "fulfil"
    ],
    "capability": "money.payment_requests:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests",
      null,
      "cancel"
    ],
    "capability": "money.payment_requests:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests",
      null,
      "excess"
    ],
    "capability": "money.payment_requests:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests",
      null,
      "remittances"
    ],
    "capability": "money.remittances:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests",
      null,
      "receipts"
    ],
    "capability": "money.receipts:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests",
      null,
      "receipts",
      null,
      "reverse"
    ],
    "capability": "money.receipts:create"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "ledger",
      "accounts"
    ],
    "capability": "ledger.journal:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "ledger",
      "journal-entries"
    ],
    "capability": "ledger.journal:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "files"
    ],
    "capability": "files.files:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "files"
    ],
    "capability": "files.files:create"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "files",
      null
    ],
    "capability": "files.files:read"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "organizations",
      null,
      "files",
      null
    ],
    "capability": "files.files:delete"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "files",
      null,
      "content"
    ],
    "capability": "files.files:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "brands"
    ],
    "capability": "branding.brands:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "brands"
    ],
    "capability": "branding.brands:create"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "organizations",
      null,
      "brands",
      null
    ],
    "capability": "branding.brands:delete"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "brands",
      null
    ],
    "capability": "branding.brands:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "brands",
      null
    ],
    "capability": "branding.brands:update"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "brands",
      null,
      "duplicate"
    ],
    "capability": "branding.brands:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "brands",
      null,
      "publish"
    ],
    "capability": "branding.brands:publish"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "brands",
      null,
      "versions"
    ],
    "capability": "branding.brands:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "brands",
      null,
      "default"
    ],
    "capability": "branding.brands:publish"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "brands",
      null,
      "archive"
    ],
    "capability": "branding.brands:update"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "brands",
      null,
      "draft",
      "theme.css"
    ],
    "capability": "branding.brands:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "rich-text",
      "clean"
    ],
    "capability": "richtext.content:clean"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "clients",
      null
    ],
    "capability": "developer.clients:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "clients",
      null
    ],
    "capability": "developer.clients:update"
  },
  {
    "method": "PUT",
    "segments": [
      "v1",
      "me",
      "devices",
      null
    ],
    "capability": "push.devices:write"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "me",
      "devices",
      null
    ],
    "capability": "push.devices:write"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "me",
      "devices"
    ],
    "capability": "push.devices:write"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "notifications"
    ],
    "capability": "push.notifications:send"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "notifications",
      null
    ],
    "capability": "push.notifications:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "receipts"
    ],
    "capability": "money.payment_requests:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "collection-accounts"
    ],
    "capability": "money.collection_accounts:write"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "collection-accounts"
    ],
    "capability": "money.collection_accounts:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "collection-accounts",
      null,
      "disconnect"
    ],
    "capability": "money.collection_accounts:write"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests",
      null,
      "collections"
    ],
    "capability": "money.collections:create"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "collections",
      null
    ],
    "capability": "money.collections:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "collections"
    ],
    "capability": "money.collections:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "collections",
      null,
      "cancel"
    ],
    "capability": "money.collections:create"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "receiving-accounts",
      null
    ],
    "capability": "money.receiving_accounts:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "receiving-accounts",
      null
    ],
    "capability": "money.receiving_accounts:update"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "receiving-accounts",
      null,
      "archive"
    ],
    "capability": "money.receiving_accounts:update"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "receiving-accounts",
      null,
      "restore"
    ],
    "capability": "money.receiving_accounts:update"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "collection-accounts",
      null
    ],
    "capability": "money.collection_accounts:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "collection-accounts",
      null,
      "reconnect"
    ],
    "capability": "money.collection_accounts:write"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "payment-requests",
      null,
      "remittances",
      null,
      "withdraw"
    ],
    "capability": "money.remittances:create"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "external-payers"
    ],
    "capability": "money.external_payers:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "external-payers",
      null
    ],
    "capability": "money.external_payers:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "external-payers",
      null
    ],
    "capability": "money.external_payers:write"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "invitations",
      null
    ],
    "capability": "identity.invitations:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "invitations",
      null
    ],
    "capability": "identity.invitations:create"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-mailboxes"
    ],
    "capability": "comms.inbound_mailboxes:manage"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-mailboxes"
    ],
    "capability": "comms.inbound_mailboxes:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-mailboxes",
      null
    ],
    "capability": "comms.inbound_mailboxes:read"
  },
  {
    "method": "PATCH",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-mailboxes",
      null
    ],
    "capability": "comms.inbound_mailboxes:manage"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-mailboxes",
      null,
      "disconnect"
    ],
    "capability": "comms.inbound_mailboxes:manage"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-mailboxes",
      null,
      "reconnect"
    ],
    "capability": "comms.inbound_mailboxes:manage"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-threads",
      null
    ],
    "capability": "comms.messages:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-messages",
      null,
      "attachments",
      null
    ],
    "capability": "comms.messages:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-messages",
      null,
      "label"
    ],
    "capability": "comms.inbound_messages:update"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-messages",
      null,
      "unlabel"
    ],
    "capability": "comms.inbound_messages:update"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-messages",
      null,
      "archive"
    ],
    "capability": "comms.inbound_messages:update"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-messages",
      null,
      "restore"
    ],
    "capability": "comms.inbound_messages:update"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-messages",
      null,
      "retry"
    ],
    "capability": "comms.inbound_messages:update"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-mailboxes",
      null,
      "purge"
    ],
    "capability": "comms.inbound_mailboxes:manage"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-messages",
      null,
      "raw"
    ],
    "capability": "comms.messages:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-mailboxes",
      null,
      "skipped-messages"
    ],
    "capability": "comms.inbound_mailboxes:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "inbound-mailboxes",
      null,
      "skipped-messages",
      null,
      "retry"
    ],
    "capability": "comms.inbound_mailboxes:manage"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "organizations",
      null,
      "ai",
      "extractions"
    ],
    "capability": "ai.extractions:invoke"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "ai",
      "extractions",
      null
    ],
    "capability": "ai.extractions:read"
  },
  {
    "method": "GET",
    "segments": [
      "v1",
      "organizations",
      null,
      "ai",
      "usage"
    ],
    "capability": "ai.extractions:read"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "end-user-verifications"
    ],
    "capability": "identity.end_users:enroll"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "end-user-verifications",
      null,
      "check"
    ],
    "capability": "identity.end_users:enroll"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "end-users"
    ],
    "capability": "identity.end_users:enroll"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "end-user-sign-ins"
    ],
    "capability": "identity.end_users:enroll"
  },
  {
    "method": "POST",
    "segments": [
      "v1",
      "end-user-passkey-assertions"
    ],
    "capability": "identity.end_users:enroll"
  },
  {
    "method": "DELETE",
    "segments": [
      "v1",
      "me",
      "end-user"
    ],
    "capability": "identity.self:manage"
  }
] as const;
